/**
 * Global Three.js or rendering context reference.
 */
export class RenderState {
  /** Instance of Three.js or another render context */
  threeInstance: any = null
}
